import { render, staticRenderFns } from "./modalInformacionPago.vue?vue&type=template&id=1060d437&scoped=true"
import script from "./modalInformacionPago.vue?vue&type=script&lang=js"
export * from "./modalInformacionPago.vue?vue&type=script&lang=js"
import style0 from "./modalInformacionPago.vue?vue&type=style&index=0&id=1060d437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060d437",
  null
  
)

export default component.exports